<template>
  <div>
      <qrcode :value="URL" :options="{ width: QRCodeWidth, margin: 1,  errorCorrectionLevel: 'M'}"></qrcode>
  </div>
</template>

<script>
export default {
  props: ["URL", "QRCodeWidth"],
  data() {
    return {};
  },
  methods: {}
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Main/QRCode.vue